import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import cn from 'classnames';

import { Form } from 'ui/components';
import { Manifest } from 'services/action';
import { UploadPOD } from './legs.upload.pod';
import { ActionDeleted } from './legs.deleted';

import _ from 'underscore'

const initialState = {
  is_delivered: true,
  is_dispute: false,
  is_disabled: false,
  received_by: '',
  cod_receive: 0,
  note: '',
  images: [],
};

export const ActionDelivered = ({
  manifest,
  legs,
  onSubmit,
  handleClose,
  onLegChanges,
  loading = false,
}) => {
  const Dispatch = useDispatch();
  const StateForm = useSelector((state) => state?.Form);
  const [
    { is_delivered, is_dispute, is_disabled, received_by, cod_receive, note, images },
    setState,
  ] = React.useState(initialState);

  const $handleCheck = async (name, val) => {
    if (name === 'is_dispute') {
      setState((prevState) => ({
        ...prevState,
        is_dispute: val,
        is_delivered: val ? false : is_delivered,
      }));
    } else {
      setState((prevState) => ({
        ...prevState,
        is_delivered: val,
        is_dispute: val ? false : is_dispute,
      }));
    }
  };

  const $handleSubmit = async () => {
    let req = null;

    let payload = {
      latitude: legs?.location?.latitude,
      longitude: legs?.location?.longitude,
    };

    if (is_delivered) {
      payload.received_by = received_by;
      payload.cod_receive = cod_receive
      payload.images =
        images?.length > 0 ? [{ type: 'delivered', urls: images }] : null;
    }

    if (is_dispute) {
      payload.disputed_note = note;
      payload.images = images;
    }

    if (is_delivered) {
      let jobs = []
      _.each(legs?.jobs, function(job) {
        let items = []
        _.each(job?.delivery_order?.shipment?.items, function(i) {
          items.push({
            item_code: i?.item_code,
            item_name: i?.item_name,
            quantity: i?.quantity,
            weight: i?.weight,
            long: i?.long,
            high: i?.high,
            wide: i?.wide,
            quantity_delivered: i?.quantity
          })
        })

        jobs.push({
          job_order_id: job?.id,
          status: "delivered",
          items: items
        })
      })

      payload.jobs = jobs

      req = await Dispatch(
        Manifest.$delivered(manifest?.id, legs?.id, payload)
      );
    } else if (is_dispute) {
      payload.action = 'disputed'
      req = await Dispatch(Manifest.$dispute(manifest?.id, legs?.id, payload));
    }

    if (req?.message === 'success') {
      if (onSubmit) onSubmit();
      if (handleClose) handleClose();

      if (legs?.cod_value > 0) {
        req = await Dispatch(
          Manifest.$collected(manifest?.id, legs?.id, {cod_receive: cod_receive})
        );
      }
    }
  };

  return (
    <div>
      <div className="p-3 py-2">
        <div className="mb-3">
          <label className="form-label required pb-1">Status Pengiriman</label>
          <div className="d-flex flex-wrap gap-3">
            <Form.Checkbox
              onChange={() =>
                $handleCheck('is_delivered', is_delivered ? false : true)
              }
              labelClass="form-label fs-8"
              label="Terkirim"
              value={is_delivered}
              iconSize={18}
              disabled={is_disabled}
            />
            {!legs?.is_receive && (
              <Form.Checkbox
                onChange={() =>
                  $handleCheck('is_dispute', is_dispute ? false : true)
                }
                labelClass="form-label fs-8"
                label="Gagal Kirim"
                value={is_dispute}
                iconSize={18}
                disabled={is_disabled}
              />
            )}
          </div>
        </div>
        <div className="row">
          <div className="col-6">
            {is_delivered && (
              <>
                <Form.Input
                  required
                  label="Diterima Oleh"
                  type="text"
                  value={received_by}
                  onChange={(e) =>
                    setState((prevState) => ({
                      ...prevState,
                      received_by: e?.target?.value,
                    }))
                  }
                  error={StateForm?.errors?.received_by}
                  disabled={is_disabled}
                />

                {legs?.cod_value > 0 && (
                  <Form.Input
                    value={cod_receive}
                    required
                    onChange={(e) => {
                      setState((prevState) => ({
                        ...prevState,
                        cod_receive: e.target.valueNumber,
                      }));
                    }}
                    type="number"
                    label="COD Diterima"
                    error={StateForm?.errors?.cod_receive}
                  />
                )}
              </>
            )}

            {is_dispute && (
              <Form.Textbox
                label="Catatan"
                required
                value={note}
                onChange={(e) =>
                  setState((prevState) => ({
                    ...prevState,
                    note: e.target.value,
                  }))
                }
                error={StateForm?.errors?.disputed_note}
                disabled={is_disabled}
              />
            )}
          </div>
          <div className="col-6">
            <UploadPOD
              isLoading={loading}
              onImageChange={(e) =>
                setState((prevState) => ({
                  ...prevState,
                  images: e,
                }))
              }
              errors={StateForm?.errors?.images}
            />
          </div>
        </div>
      </div>

      <div className="card-footer-gray row border-top p-3 m-0">
        <div className='col-6'>
          <button
            className={cn(
              'btn btn-sm btn-success w-100',
              StateForm?.loading ? 'btn-loading' : ''
            )}
            onClick={$handleSubmit}
          >
            Simpan
          </button>
        </div>
        {(!legs?.is_receive) && (
          <div className='col-6'>
            <ActionDeleted
              manifest={manifest}
              legs={legs}
              handleClose={handleClose}
              onSubmit={onSubmit}
              onLegChanges={onLegChanges}
            />
          </div>
        )}
      </div>
    </div>
  );
};
